import React from 'react';

interface AppLogoProps {
  size?: 'sm' | 'md' | 'lg';
  animated?: boolean;
}

export const AppLogo: React.FC<AppLogoProps> = ({ 
  size = 'md', 
  animated = true 
}) => { 
  const sizeClasses = {
    sm: { container: 'h-16 w-16', icon: 'h-14 w-14' },
    md: { container: 'h-20 w-20', icon: 'h-18 w-18' },
    lg: { container: 'h-24 w-24', icon: 'h-22 w-22' }
  };

  const { container, icon } = sizeClasses[size];

  return (
    <div className={`relative ${container} flex items-center justify-center`}>
      <img
        src="/logo.png"
        alt="PromptOS Logo"
        className={`${icon} relative z-10`} 
      />
    </div>
  );
};